<template>
  <div class="">
    <CoverPage />

    <WishlistCard />
  </div>
</template>
<script>
import WishlistCard from "./components/WishlistCard";
import "../../scss/index.scss";
import CoverPage from "./components/CoverPage.vue";
export default {
  data() {
    return {
      // key: value,
    };
  },
  components: {
    WishlistCard,
    CoverPage,
  },
  metaInfo: {
    title: "Caregiver Saathi - online courses - Wishlist",
    meta: [
      {
        name: "keyword",
        content: "Caregiver Saathi Foundation",
      },
      {
        name: "description",
        content:
          "Get started on your learning journey with your favourite caregiving courses.",
      },
    ],
  },
};
</script>
